import Vue from "vue";
import about from './about';
import animated from 'animate.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import './../../css/global.scss';
import 'swiper/dist/css/swiper.css'


Vue.use(animated)
Vue.use(VueAwesomeSwiper);


new Vue({
    render: h => h(about)
}).$mount("#app");
